import axios from './index'
import url from './url'
// 引用fetch.js

// 根据模块id获取分组分类
function getEduGroup (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getMainCategory`,
    { params: typeOne }
  )
}

function getEduLists (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/lists`,
    { params: typeOne }
  )
}

// 根据选中的menuId获取判断条件
function getEduSort (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/sort`,
    { params: typeOne }
  )
}

// 列表页查询条件（根据用户属性）
function getSortByUsertype (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/getSortByUsertype`,
    { params: typeOne }
  )
}

// 获取学校、老师、培训机构详情
function getEduDetails (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/details`,
    { params: typeOne }
  )
}

// 获取教师备注列表
function getEduRemarkList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/getTeacherBeizhuList`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 删除教师备注
function deleteEduRemark (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/delTeacherBeizhu`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 添加教师备注
function addEduRemark (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/edu/addTeacherBeizhu`,
    typeOne,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 获取老师点赞数量
function getEduLikeNum (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/getTeacherLikecount`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 获取老师收藏数量
function getEduCollectNum (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/getTeacherCollectcount`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 获取老师评分
function getEduAverageNum (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/getTeacherAverage`,
    { params: typeOne }
  )
}

// 获取老师收到的花数量
function getEduFlowerNum (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/getTeacherFlowercount`,
    { params: typeOne }
  )
}

// 老师点赞/取消点赞
function getEduLike (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/likeTeacher`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 老师收藏/取消收藏
function getEduCollect (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/collectTeacher`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 老师评分
function getEduRating (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/scoreTeacher`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 获取礼物花列表
function getEduFlowerList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getFlowerList`,
    { params: typeOne }
  )
}

// 给老师送花
function sendFlower (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/edu/sendTeacherFlowers`,
    typeOne,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 查询礼物支付状态
function updatePayStatus (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/queryFlowerWxpayStatus`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 分享
function share (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/share`,
    { params: typeOne }
  )
}

// 获取学校组织
function getSchoolZuzhi (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/school_zuzhi`,
    { params: typeOne }
  )
}

// 获取学校组织
function getSchoolTeacher (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/school_teacher`,
    { params: typeOne }
  )
}

// 获取学校在校生
function getSchoolZxs (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/school_zxs`,
    { params: typeOne }
  )
}

// 获取校友中心基本信息
function getAlumnsBasic (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/alumns_basic`,
    { params: typeOne }
  )
}

// 获取校友中心最新一条公告
function getNewNoticeOne (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/new_notice_one`,
    { params: typeOne }
  )
}

// 获取校友中心最新一届毕业生
function getNewBiyeshengOne (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/new_biyesheng_one`,
    { params: typeOne }
  )
}

// 获取5条最新的学校风采、校园公告、校园信息
function getLastFCGGXX (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/school_notice_five`,
    { params: typeOne }
  )
}

// 获取5条最新的学校风采、校园公告、校园信息
function getschoolNoticeLists (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/school_notice_lists`,
    { params: typeOne }
  )
}

// 获取5条最新的学校风采、校园公告、校园详情
function getSchoolNoticeDetail (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/school_notice_detail`,
    { params: typeOne }
  )
}

// 获取校友中心公告详情
function getAlumnsNoticeDetail (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/alumns_notice_detail`,
    { params: typeOne }
  )
}

// 获取5条最新的学校风采、校园公告、校园信息
function getAlumnsBiyejieLists (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/alumns_biyejie_lists`,
    { params: typeOne }
  )
}

// 获取5条最新的学校风采、校园公告、校园信息
function getAalumnsBiyejieDetail (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/alumns_biyejie_detail`,
    { params: typeOne }
  )
}

// 获取校友中心公告列表
function getAlumnsNoticeLists (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/alumns_notice_lists`,
    { params: typeOne }
  )
}

// 老师部分-------------------------------------------

// 获取校友中心公告列表
function getNewKewuSeven (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/new_kewu_seven`,
    { params: typeOne }
  )
}

// 获取最新8条文字课件
function getNnewWenziEight (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/new_wenzi_kejian_eight`,
    { params: typeOne }
  )
}

// 获取最新10条免费视频/收费视频课件
function getNewVideoTen (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/new_video_ten`,
    { params: typeOne }
  )
}

// 获取课务列表
function getKewuList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/kewu_list`,
    { params: typeOne }
  )
}

// 获取课务详情
function getKewuDetail (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/kewu_detail`,
    { params: typeOne }
  )
}

// 获取文字/免费视频/收费视频课件列表
function getKejianList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/kejian_list`,
    { params: typeOne }
  )
}

// 获取课件留言列表
function getKejianMessL (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/kejian_message_list`,
    { params: typeOne }
  )
}

// 获取文字/免费视频/收费视频课件详情
function getKejianDetail (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/kejian_detail`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 发送留言（需用户登录）
function getPostMessage (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/edu/post_message`,
    typeOne,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 老师回复留言（需登录）
function getPostReplyM (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/edu/post_reply_message`,
    typeOne,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 获取课件订单信息
function getKejianInfo (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/getKejianInfo`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 老师回复留言（需登录）
function submitKejianOrder (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/edu/submitKejianOrder`,
    typeOne,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 查询待支付课件订单
function queryKejianOrder (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/queryKejianOrder`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 获取微信支付二维码
function getGoodsQrcode (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/getGoodsQrcode`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 获取微信支付二维码
function queryOrder (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/queryOrder`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 学校/机构/老师浏览+1
function getBrowse (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/browse`,
    { params: typeOne }
  )
}

// 获取机构/学校属性
function getLeibie (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getLeibie`,
    { params: typeOne }
  )
}

// 获取4个推荐学校机构
function getTuijianSchool (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/edu/tuijianSchool`,
    { params: typeOne }
  )
}

export {
  getEduGroup,
  getEduLists,
  getEduSort,
  getSortByUsertype,
  getEduDetails,
  getEduRemarkList,
  addEduRemark,
  deleteEduRemark,
  getEduLikeNum,
  getEduCollectNum,
  getEduAverageNum,
  getEduFlowerNum,
  getSchoolZuzhi,
  getEduFlowerList,
  sendFlower,
  updatePayStatus,
  getSchoolTeacher,
  getSchoolZxs,
  getAlumnsBasic,
  getNewNoticeOne,
  getNewBiyeshengOne,
  getLastFCGGXX,
  getschoolNoticeLists,
  getSchoolNoticeDetail,
  getAlumnsNoticeDetail,
  getAlumnsBiyejieLists,
  getAalumnsBiyejieDetail,
  getAlumnsNoticeLists,
  getNewKewuSeven,
  getNnewWenziEight,
  getNewVideoTen,
  getKewuList,
  getKewuDetail,
  getKejianList,
  getKejianMessL,
  getKejianDetail,
  getPostMessage,
  getPostReplyM,
  getKejianInfo,
  submitKejianOrder,
  queryKejianOrder,
  getGoodsQrcode,
  queryOrder,
  getBrowse,
  getLeibie,
  getTuijianSchool,
  getEduLike,
  getEduCollect,
  getEduRating,
  share
}



// WEBPACK FOOTER //
// ./src/axios/education.js